import { Component, OnInit } from '@angular/core';
import { IT_MANAGEMENT_COMPONENT, UserModuleApiSuffixModels } from '@app/modules';
import { AppState } from '@app/reducers';
import { CrudType, IApplicationResponse, LoggedInUserModel, ModulesBasedApiSuffix, ReusablePrimeNGTableFeatureService, SnackbarService, addDefaultTableObjectProperties, checkUserPermissionsByCategory, currentComponentPageBasedPermissionsSelector$, onActionSubmittedUtil, prepareDynamicTableTabsFromPermissions, prepareGetRequestHttpParams } from '@app/shared';
import { CrudService, RxjsService } from '@app/shared/services';
import { loggedInUserData } from '@modules/others';
import { DivisionModel } from '@modules/user/models';
import { Store } from '@ngrx/store';
import { DialogService } from 'primeng/api';
import { combineLatest } from 'rxjs';
import { PrimeNgTableVariablesModel } from '../../../../../shared/models/prime-ng-table-list-component-variables.model';
import { DivisionAddEditComponent } from './division-add-edit.component';
@Component({
  selector: 'app-division-list',
  templateUrl: './division-list.component.html',
})
export class DivisionListComponent extends PrimeNgTableVariablesModel implements OnInit {
  primengTableConfigProperties: any = {
    tableCaption: 'Division',
    selectedTabIndex: 0,
    breadCrumbItems: [{ displayName: 'IT Management ' }, { displayName: 'Division List' }],
    tableComponentConfigs: {
      tabsList: [
        {
          caption: 'Division',
          dataKey: 'divisionId',
          enableAction: true,
          enableMultiDeleteActionBtn: true,
          enableStatusActiveAction: true,
          checkBox: true,
          enableRowDelete: true,
          columns: [{ field: 'divisionCode', header: 'Division Code' },
          { field: 'divisionName', header: 'Division Name' },
          { field: 'regionName', header: 'Region Name' },
          { field: 'isActive', header: 'Status' }
          ],
          apiSuffixModel: UserModuleApiSuffixModels.DIVISIONS,
          moduleName: ModulesBasedApiSuffix.IT_MANAGEMENT
        }]
    }
  }

  constructor(private crudService: CrudService,
    private rxjsService: RxjsService,
    private store: Store<AppState>,
    public dialogService: DialogService,
    public snackbarService: SnackbarService,
    private reusablePrimeNGTableFeatureService: ReusablePrimeNGTableFeatureService) {
    super();
    this.primengTableConfigProperties = addDefaultTableObjectProperties(this.primengTableConfigProperties);
  }

  ngOnInit(): void {
    this.getDivisions();
    this.combineLatestNgrxStoreData();
  }

  combineLatestNgrxStoreData() {
    combineLatest([
      this.store.select(loggedInUserData),
      this.store.select(currentComponentPageBasedPermissionsSelector$)]
    ).subscribe((response) => {
      this.loggedInUserData = new LoggedInUserModel(response[0]);
      let permission = response[1][IT_MANAGEMENT_COMPONENT.DIVISION]
      if (permission) {
        let prepareDynamicTableTabsFromPermissionsObj = prepareDynamicTableTabsFromPermissions(this.primengTableConfigProperties, permission);
        this.primengTableConfigProperties = prepareDynamicTableTabsFromPermissionsObj['primengTableConfigProperties'];
      }
    });
  }


  getDivisions(pageIndex?: string, pageSize?: string, otherParams?: object): void {
    this.loading = true;
    this.crudService.get(ModulesBasedApiSuffix.IT_MANAGEMENT, UserModuleApiSuffixModels.DIVISIONS, undefined, false,
      prepareGetRequestHttpParams(pageIndex, pageSize, otherParams)).subscribe((response: IApplicationResponse) => {
        if (response.isSuccess && response.statusCode === 200 && response.resources) {
          this.dataList = response.resources
          this.totalRecords = response.totalCount;
          this.loading = false;
        }
        this.rxjsService.setGlobalLoaderProperty(false);
      });
  }

  onCRUDRequested(type: CrudType | string, row?: object, searchObj?): void {
    switch (type) {
      case CrudType.CREATE:
        if (checkUserPermissionsByCategory.bind(this, CrudType.CREATE)) {
          this.openAddEditPage(CrudType.CREATE, row);
        }
        break;
      case CrudType.GET:
        this.first = row["pageIndex"] && row["pageSize"] ? row["pageIndex"] * row["pageSize"] : 0;
        this.getDivisions(row["pageIndex"], row["pageSize"], searchObj);
        break;
      case CrudType.VIEW:
        if (checkUserPermissionsByCategory.bind(this, CrudType.EDIT)) {
          this.openAddEditPage(CrudType.VIEW, row);
        }
        break;
      case CrudType.DELETE:
        if (checkUserPermissionsByCategory.bind(this, CrudType.ROW_DELETE)) {
          this.reusablePrimeNGTableFeatureService.openDynamicDeleteDialog(this.selectedTabIndex, this.selectedRows,
            this.primengTableConfigProperties, row)?.onClose?.subscribe((result) => {
              if (result) {
                this.selectedRows = [];
                this.getDivisions();
              }
            });
        }
        break;
      case CrudType.STATUS_POPUP:
        this.reusablePrimeNGTableFeatureService.openDynamicChangeStatusDialog(this.selectedTabIndex,
          this.primengTableConfigProperties, row)?.onClose?.subscribe((result) => {
            if (!result) {
              this.dataList[searchObj].isActive = this.dataList[searchObj].isActive ? false : true;
            }
          });
        break;
    }
  }

  onActionSubmited(e) {
    onActionSubmittedUtil(e, this.onCRUDRequested.bind(this));
  }

  onChangeSelecedRows(e) {
    this.selectedRows = e;
  }

  openAddEditPage(type: CrudType | string, divisionModel?: DivisionModel | any): void {
    let data = new DivisionModel(divisionModel);
    const ref = this.dialogService.open(DivisionAddEditComponent, {
      baseZIndex: 10000,
      width: "450px",
      data: data,
      showHeader: false,
    });
    ref.onClose.subscribe((resp) => {
      if (resp) {
        this.getDivisions();
      }
    });
  }
}
